
<canvas id="display" class="display" width="1920px" height="1080px"></canvas>
<video id="target-video" class="target-video" src="assets/images/output01.mp4" autoplay muted></video>
<canvas #canvas
id="drowing" 
class="drowing"
(mousemove)="onMouseMove($event)"
(mousedown)="onMouseDown($event)"
(mouseup)="onMouseUp($event)"
width="1920px" height="1080px">
</canvas>

  